import { render } from "./AuthorPage.vue?vue&type=template&id=23ef85ea&ts=true"
import script from "./AuthorPage.vue?vue&type=script&lang=ts"
export * from "./AuthorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__